import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { detectInitialLanguage, DEFAULT_LANGUAGE } from "./language";
import { resources } from "./resources";

i18n.use(initReactI18next).init({
  resources,
  lng: detectInitialLanguage(),
  fallbackLng: DEFAULT_LANGUAGE,
  interpolation: {
    escapeValue: false
  },
  returnNull: false
});

export default i18n;
